<template>
    <div ref="mainHigh" class="mianLogin">
        <div class="upest" ref="upest">
            <span>当前为第一题</span>
        </div>
        <div ref="dash" class="dash" @click="tip(true)">
        </div>
        <div class="upestModel" ref="upestModel">
            <h3>提 示</h3>
            <span>您当前已经不符合高企申报条件，是否继续答题</span>
            <div style="margin-top:4rem">
                <a-button class="subtn" style="margin-right:5rem" size="large" type="primary"
                          @click="tip(false)">查看原因
                </a-button>
                <a-button class="subtn" size="large" type="primary" @click="tip(true)">确定</a-button>
            </div>
        </div>
        <div class="backTop">
            <LeftOutlined class="fl" @click="goMore('/webHighEnterpriseEvaluation?bottom_nav_ico=0')"/>
            <div class="lineStep">
                <a-divider style="background-color: #acabab;"/>
            </div>
            <div class="currentcon">
                <div class="curfont">
                    <div class="circle" :class="{ selctActive: curent > 0 }">
                        <CheckOutlined/>
                    </div>
                </div>
                <div class="curfont">
                    <div class="circle" :class="{ selctActive: curent > 8 }">
                        <CheckOutlined v-if="curent > 8"/>
                        <i v-else>2</i>
                    </div>
                </div>
                <div class="curfont">
                    <div class="circle" :class="{ selctActive: curent > 10 }">
                        <CheckOutlined v-if="curent > 10"/>
                        <i v-else>3</i>
                    </div>
                </div>
                <div class="curfont">
                    <div class="circle" :class="{ selctActive: curent > 13 }">
                        <CheckOutlined v-if="curent > 13"/>
                        <i v-else>4</i>
                    </div>
                </div>
            </div>
            <div class="currentcon" style="margin-top: .2rem;">
                <span class="curfont" :class="{ selAcFont: curent > 0 }">基础条件</span>
                <span class="curfont" :class="{ selAcFont: curent > 8 }">财务成长性</span>
                <span class="curfont" :class="{ selAcFont: curent > 10 }">知识产权和<br>成果转化</span>
                <span class="curfont" :class="{ selAcFont: curent > 13 }">研发组织<br>管理水平</span>
            </div>
        </div>
        <div class="testBody" v-for="(item, key) in form" :key="key" :class="{ showTestNow: curent == key + 1 }">
            <div class="numShow"><span>{{ curent }}/</span>17.</div>
            <p>
                <span v-if="key == 6">
                    近三年在<span style="color:red">境外</span>研发费用占全部研发费用的比例(%)
                </span>
                <span v-else>{{ item.questions }}  <span style="color:red;" v-if="key == '2'">(请选择到最后一级所属领域)</span></span>
            </p>
            <p ref="myDiv"></p>
            <p style="color:#a8a8a8;font-size: .8rem;">{{ item.explainInfo }}</p>
            <div class="testSelct" v-if="item.questionsType == '0'">
                <ul v-if="key != 2">
                    <Li v-for="(child, keychild) in item.evaluateOptions" :key="keychild"
                        :class="{ liActive: testLi == child.optionInfo }"
                        @click="selctEvaluate(key, item.id, child.optionInfo, item.evaluateFlag, item.questionsType, item.groupId)">
                        <span class="circle">
                            <CheckOutlined/>
                        </span>
                        <span>{{ child.optionContent }} </span>
                    </Li>
                </ul>
                <div v-else>
                    <a-directory-tree
                        :tree-data='treeData'
                        @select="(answerId,info)=>onTreeNodeSelect(answerId,info,key,item.id,'',item.evaluateFlag, item.questionsType, item.groupId)"
                        :replaceFields='expandedKeys'>
                    </a-directory-tree>
                </div>
            </div>
            <div class="testInput" v-if="item.questionsType == '1'">
                <div style="margin-bottom:.2rem" v-for="(childInput, keyInput) in item.evaluateMbs" :key="keyInput">
                    <span v-if="childInput.fillBlank">{{ childInput.fillBlank }}<br/></span>
                    <input
                        @blur="selctEvaluate(key, item.id, childInput.optionInfo, item.evaluateFlag, item.questionsType, item.groupId)"
                        v-model="BlankValue[keyInput]" type="tel">
                </div>
            </div>
        </div>
        <div class="buttomBtn" v-if="submitBtn">
            <div class="btn">
                <a-button class="subtn" style="background:#fff;color:#1c4ff7;border:.1rem solid #1c4ff7" size="large"
                          @click="submit(false)">上一题
                </a-button>
            </div>
            <div class="btn">
                <a-button class="subtn" size="large" type="primary" v-if="curent == curentLength"
                          @click="submit(true)">确定提交
                </a-button>
                <a-button class="subtn" size="large" type="primary" v-else @click="submit(true)">下一题</a-button>
            </div>
        </div>
    </div>
</template>

<script>
import {basicsEvaluateInfo, basicsEvaluateRecords, basicsEvaluateResult} from "@/api/webHighEnterpriseEvaluation";
import {ls} from "@/utils/util";
import {basicsEvaluateOption} from "../../../../api/webHighEnterpriseEvaluation";

export default {

    data() {
        return {
            treeData: [],
            expandedKeys: {
                children: 'children', title: 'optionContent', key: 'id' // 看你的接口返回字段是什么，对应匹配就行了
            },
            newkewords: null,
            submitBtn: true,
            selAc: 0, //头部切换
            curent: 1,
            curentLength: 0,
            form: null,
            keyNum: 0,
            testLi: null,
            // 当前
            nowId: null,
            nowFlag: null,
            nowType: null,
            BlankValue: [],
            fillBlankValue: '',
            answerId:''
        }
    },
    mounted() {
        this.getEvaluateInfo() //获取出事说明
        this.$refs.mainHigh.style.height = window.innerHeight + 'px'
    },
    methods: {
        onTreeNodeSelect(answerId,info,key, id, value, flag, type) {
            if(info.node.dataRef.children.length == 0){
                this.keyNum = key
                this.testLi = info.node.dataRef.optionInfo
                this.nowId = id
                this.nowFlag = flag
                this.fillBlankValue = info.node.dataRef.optionInfo
                this.nowType = type
                this.answerId = answerId[0]
            }else{
                this.keyNum = key
                this.testLi = ''
                this.nowId = ''
                this.nowFlag = flag
                this.fillBlankValue = ''
                this.nowType = ''
                this.answerId = ''
            }
        },
        getTreeList() {
            this.getAction({
                    url: basicsEvaluateOption.listTree,
                    params: {questionsId: 3}
                }
            ).then((res) => {
                this.treeData = res
            })
        },
// 结果提交
        submitEvaluate() {
            this.postAction({
                    url: basicsEvaluateResult.submitEvaluate,
                    params: {
                        user: ls.get('wxLoginPhone'),
                        evaluateFlag: this.nowFlag
                    }
                }
            ).then((res) => {
                if (res) {
                    this.$refs.dash.style.display = 'none'
                    this.$refs.upestModel.style.display = 'none'
                    this.goMore('/webHighEnterpriseEvaluation/detail', this.nowFlag)
                }
            })
        }
        ,
//不合格提示
        tip(active) {
            if (active) {
                this.clearEvaluate()
                this.$refs.dash.style.display = 'none'
                this.$refs.upestModel.style.display = 'none'
                this.nowId = this.form[this.keyNum - 1].id
                this.nowType = this.form[this.keyNum - 1].questionsType
                this.getDetail(this.form[this.keyNum + 1].id)
                ++this.keyNum
                ++this.curent
                this.submitBtn = true

            } else {
                this.submitEvaluate()
            }
        }
        ,
// 换题清空
        clearEvaluate() {
            this.testLi = null,
            // 当前
            this.nowId = null,
            this.nowType = null,
            this.BlankValue = [],
            this.fillBlankValue = ''
        }
        ,
// 选择题
        selctEvaluate(key, id, value, flag, type) {
            this.keyNum = key
            this.testLi = value
            this.nowId = id
            this.nowFlag = flag
            this.fillBlankValue = value
            this.nowType = type
            // this.selAc=parseInt(groupId)-1
            console.log(key, id, value, flag, type)
        }
        ,
//获取详情
        getDetail(id) {
            this.getAction({
                    url: basicsEvaluateRecords.questionInfo,
                    params: {
                        questionsId: id,
                        evaluateFlag: this.nowFlag
                    }
                }
            ).then((res) => {
                if (res) {
                    this.testLi = res.answer
                    this.fillBlankValue = res.answer
                    if (res.remark.split(',').length > 2) {
                        this.BlankValue[0] = res.remark.split(',')[0]
                        this.BlankValue[1] = res.remark.split(',')[1]
                        this.BlankValue[2] = res.remark.split(',')[2]
                    } else {
                        this.BlankValue[0] = res.remark.split(',')[0]
                        this.fillBlankValue = res.answer
                    }
                    this.nowType = res.questionsType
                    this.nowId = res.questionsId
                    this.submitBtn = true
                }
            })
        }
        ,
//获取说明
        getEvaluateInfo() {
            this.getAction({
                    url: basicsEvaluateInfo.getEvaluateInfo,
                }
            ).then((res) => {
                this.getEvaluate(res.id)
            })
        }
        ,
//获取试题
        getEvaluate(id) {
            this.getAction({
                    url: basicsEvaluateInfo.evaluateInfo,
                    params: {
                        evaluateId: id
                    }
                }
            ).then((res) => {
                this.form = res
                this.curentLength = res.length
            })
        }
        ,
        //保存试题
        saveEvaluate(id, value, flag) {
            this.postAction({
                    url: basicsEvaluateRecords.saveOrUpdate,
                    params: {
                        questionsId: id,
                        evaluateFlag: flag,
                        answer: value,
                        remark3:this.answerId,
                        remark: this.BlankValue.toString(),
                        questionsType: this.form[this.keyNum].questionsType,
                        user: ls.get('wxLoginPhone')
                    }
                }
            ).then((res) => {
                if (res) {
                    if (this.curent == this.curentLength) {
                        alert('提交完成！')
                    } else {
                        this.clearEvaluate()
                        this.nowId = this.form[this.keyNum].id
                        this.nowType = this.form[this.keyNum + 1].questionsType
                        this.getDetail(this.form[this.keyNum + 1].id)
                        ++this.keyNum
                        ++this.curent
                    }
                    this.submitBtn = true
                } else {
                    this.$refs.dash.style.display = 'block'
                    this.$refs.upestModel.style.display = 'block'
                    this.submitBtn = true
                }
            }).finally(()=>{
                this.submitBtn = true
            })
        }
        ,
       // 换题保存当前
        submit(doIt) {
            this.submitBtn = false
            if (this.curent == '1') {
                this.getTreeList()
            }
            if (doIt) {
                if (this.fillBlankValue || this.BlankValue[0]) {
                    if (this.nowType == '1') {
                        if (this.BlankValue.length > 1) {
                            if (this.BlankValue[0] && this.BlankValue[1] && this.BlankValue[2]) {
                                let numone = this.BlankValue[1] / this.BlankValue[0]
                                let numtwo = this.BlankValue[2] / this.BlankValue[1]
                                if (this.BlankValue[1] == 0 && this.BlankValue[2] != 0 && this.BlankValue[0] == 0) {
                                    this.fillBlankValue = this.BlankValue[2] * 100
                                } else if (this.BlankValue[1] == 0 && this.BlankValue[2] == 0 && this.BlankValue[0] != 0) {
                                    this.fillBlankValue = this.BlankValue[1] * 100
                                } else {
                                    if (this.BlankValue[0] == 0 || this.BlankValue[1] == 0) {
                                        numone = 0
                                    }
                                    if (this.BlankValue[1] == 0 || this.BlankValue[2] == 0) {
                                        numtwo = 0
                                    }
                                    if (numone == 0 && numtwo == 0) {
                                        this.fillBlankValue = 0
                                    } else {
                                        this.fillBlankValue = ((numone + numtwo) / 2 - 1) * 100
                                    }
                                }
                                this.fillBlankValue = this.fillBlankValue.toFixed(2).toString()
                            } else {
                                alert('请完成作答！')
                                this.submitBtn = true
                                return false
                            }
                        } else {
                            if(this.questionsId !== '0'){
                                this.fillBlankValue = this.BlankValue[0]
                                this.fillBlankValue = this.fillBlankValue.toString()
                            }
                        }
                    }
                    if (this.curent == this.curentLength) {
                        this.saveEvaluate(this.nowId, this.fillBlankValue, this.nowFlag)
                        setTimeout(() => {
                            this.submitEvaluate()
                        }, 2000);
                    } else {
                        if (this.nowType == 0) {
                            this.saveEvaluate(this.nowId, this.testLi, this.nowFlag)
                            this.fillBlankValue = null
                        } else {
                            this.saveEvaluate(this.nowId, this.fillBlankValue, this.nowFlag)
                            this.fillBlankValue = null
                        }

                    }

                } else {
                    alert('请完成作答！')
                    this.submitBtn = true
                }


            } else {
                if (this.curent == 1) {
                    clearTimeout(timer)
                    this.$refs.upest.style.display = 'block'
                    this.submitBtn = true
                    const timer = setTimeout(() => {
                        this.$refs.upest.style.display = 'none'
                    }, 1000);
                } else {
                    this.BlankValue = [],
                        this.fillBlankValue = ''
                    this.getDetail(this.form[this.keyNum - 1].id)
                    --this.keyNum
                    --this.curent
                }
            }
        }
        ,
//路由跳转
        goMore(url, str) {
            if (str) {
                this.$router.push({path: url, query: {flag: str}})
            } else {
                this.$router.push(url)
            }
        }
        ,
    }
}
;
</script>
<style lang="less" scoped>
::v-deep .ant-tree-iconEle{
    display: none !important;
}
::v-deep .ant-tree-node-content-wrapper::before{
    background: #fff;
}

//::v-deep .ant-tree li .ant-tree-node-content-wrapper,
//::v-deep .ant-tree li span.ant-tree-switcher, ::v-deep .ant-tree li span.ant-tree-iconEle{
//    line-height: 36px;
//}
//::v-deep .ant-tree.ant-tree-directory > li span.ant-tree-node-content-wrapper::before,
//::v-deep .ant-tree.ant-tree-directory .ant-tree-child-tree > li span.ant-tree-node-content-wrapper::before{
//    height: 36px;
//}
//::v-deep .ant-tree li{
//    padding:10px 0;
//}

::v-deep .ant-tree.ant-tree-directory > li.ant-tree-treenode-selected > span.ant-tree-node-content-wrapper::before,
::v-deep .ant-tree.ant-tree-directory .ant-tree-child-tree > li.ant-tree-treenode-selected > span.ant-tree-node-content-wrapper::before,
::v-deep .ant-tree.ant-tree-directory .ant-tree-child-tree > li.ant-tree-treenode-selected > span.ant-tree-node-content-wrapper::before,
::v-deep .ant-tree.ant-tree-directory > li.ant-tree-treenode-selected > span.ant-tree-node-content-wrapper::before,
::v-deep .ant-tree.ant-tree-directory .ant-tree-child-tree > li.ant-tree-treenode-selected > span.ant-tree-node-content-wrapper::before{
    background: #dbe0f1;
    border:1px solid #1c4ff7;
}
::v-deep .ant-tree.ant-tree-directory > li.ant-tree-treenode-selected > span.ant-tree-switcher,
.ant-tree.ant-tree-directory .ant-tree-child-tree > li.ant-tree-treenode-selected > span.ant-tree-switcher{
    color:#000;
}
::v-deep .ant-tree.ant-tree-directory > li.ant-tree-treenode-selected > span.ant-tree-switcher,
::v-deep .ant-tree.ant-tree-directory .ant-tree-child-tree > li.ant-tree-treenode-selected > span.ant-tree-switcher{
    color:#000;
}
::v-deep .ant-tree-title{
    color:#000;
}
.mianLogin {
    position: relative;
    font-family: '微软雅黑';
    width: 100%;
    background: #f1f1f1;
    display: flex;
    flex-direction: column;
    align-items: center;

    .dash {
        position: fixed;
        z-index: 9;
        display: none;
        width: 100vw;
        height: 100vh;
        background: rgba(0, 0, 0, 0.7);
    }

    .upest {
        position: fixed;
        z-index: 999;
        display: none;
        text-align: center;
        margin-top: 30rem;

        span {
            background: #acacac;
            display: inline-block;
            padding: .2rem .4rem;
        }
    }

    .upestModel {
        position: fixed;
        z-index: 999;
        font-size: .9rem;
        width: 92vw;
        padding: 1rem .5rem;
        border-radius: 1rem;
        display: none;
        background: #fff;
        text-align: center;
        margin-top: 20rem;
        font-family: '宋体';

        h3 {
            margin-bottom: 1rem;
        }
    }

    .backTop {
        background: #fff;
        width: 100%;
        text-align: center;
        padding-top: .1rem;
        padding-bottom: .3rem;
        font-size: 1.1rem;
        display: flex;
        position: relative;
        flex-direction: column;

        .fl {
            text-align: left;
            margin: .3rem 0 0 1rem;
        }

        .lineStep {
            position: absolute;
            margin: 0 auto;
            left: 0;
            right: 0;
            top: .8rem;
            width: 80vw;
        }

        .currentcon {
            position: relative;
            margin-top: .2rem;
            align-items: center;
            justify-content: center;
            font-size: 1rem;
            color: #999;
            display: flex;

            .curfont {
                font-size: .7rem;
                flex: 1;
                display: flex;
                align-items: center;
                justify-content: center;

                .circle {
                    i {
                        color: #999;
                        font-style: normal;
                    }

                    width: 1.25rem;
                    font-size: .5rem;
                    line-height: .5rem;
                    border: .1rem solid #999;
                    box-shadow: 1px 1px 1px 10px #fff;
                    display: flex;
                    color: #fff;
                    background: #fff;
                    padding: .3rem;
                    align-items: center;
                    justify-content: center;
                    border-radius: 1rem;
                }
            }

            .selAcFont {
                color: #1c4ff7;
            }

            .selctActive {
                border: .1rem solid #1c4ff7 !important;
                background: #1c4ff7 !important;
                color: #fff !important;
                font-weight: bold;
            }
        }
    }


    .input-groud {
        margin: .5rem 0;
        display: flex;
        flex-direction: column;
        width: 95vw;
        padding: 1.1rem 1.1rem;
        background: #fff;
        position: relative;
        border-radius: .4rem;

        h4 {
            margin-bottom: .8rem;
        }

        span {
            background: #d4feff;
            padding: 0 .2rem;
            color: rgb(0, 119, 255);
        }
    }

    .testBody {
        width: 100%;
        height: 70vh;
        padding: .2rem 1rem 1rem;
        overflow: auto;
        display: none;
        font-size: .9rem;

        .numShow {
            font-size: 1.4rem;

            span {
                color: #1c4ff7
            }
        }

        .testSelct {
            ul {
            }

            li {
                display: flex;
                font-size: .9rem;
                padding: .5rem 1rem;
                margin-top: .5rem;
                border-radius: .6rem;
                border: .1rem solid #fff;
                background: #fff;

                .circle {
                    width: 1.1rem;
                    height: 1.1rem;
                    font-size: .7rem;
                    margin-top: .15rem;
                    margin-right: 1rem;
                    border: .1rem solid #999;
                    display: flex;
                    background: #fff;
                    color: #fff;
                    padding: .4rem;
                    align-items: center;
                    justify-content: center;
                    border-radius: 1rem;
                }
            }

            .liActive {
                border: .1rem solid #1c4ff7;
                background: rgba(28, 79, 247, 0.1);

                .circle {
                    background: #1c4ff7;
                    color: #fff;
                    border: .1rem solid #1c4ff7;
                    font-weight: bold;
                }

            }
        }

        .testInput {
            margin-top: .2rem;
            display: flex;
            flex-direction: column;

            input {
                width: 100%;
                padding: .5rem 1rem;
                margin-top: .1rem;
                border-radius: .6rem;
                border: .1rem solid #fff;
                background: #fff;

                &:focus {
                    background: rgba(28, 79, 247, 0.1);
                    border-style: none;
                    outline: none;
                    border: .1rem solid #1c4ff7;
                }
            }
        }
    }

    .showTestNow {
        display: block;
    }

    .buttomBtn {
        width: 100%;
        display: flex;
        padding: 1.5rem 0;
        background: #fff;
        position: absolute;
        bottom: 0;

        .btn {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .subtn {
            width: 80%;
            padding: .6rem 2rem 2.4rem;
            font-size: 1.1rem;
            border-radius: .4rem;
            background: #1c4ff7;
            text-align: center;
        }
    }
}</style>
